import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const MySessions = () => {
  const navigate = useNavigate();
  useEffect(() => { navigate("/create-notes", { replace: true }); }, [navigate]);
  return null;
};

export default MySessions;
